import React from "react";

import NTMXGrid from "../../components/NTMXGrid";
import {useGetVendorsPaged} from "../../services/ContentManager";
import {useSnackbar} from "notistack";
import {useQueryClient} from "react-query";
import RenderBoolean from "../../components/cellRender/RenderBoolean";
import {getErrorMessage, put, DASH_VENDORS} from "../../services/Client";
import {Link} from "react-router-dom";
import {IconButton, Paper, Tooltip} from "@mui/material";
import {Visibility} from "@mui/icons-material";
import {useTranslation} from "react-i18next";

export default function VendorManagement() {

    const {t} = useTranslation();
    let queryClient = useQueryClient();
    const {enqueueSnackbar} = useSnackbar()

    // Il filtro server-side gira solo sui campi testuali: su numerici ed enum un filtro MUI
    // produrrebbe predicati incompatibili col tipo colonna.
    const [inputFilters, setInputFilters] = React.useState({
        "filters": [],
        "pagination": {"page": 0, "pageSize": 25},
        "sort": {"field": "businessName", "sort": "asc"}
    });
    let {vendors, status} = useGetVendorsPaged(btoa(JSON.stringify(inputFilters)))

    const handleFilterModelChange = React.useCallback((filterModel) => {
        setInputFilters(prev => ({
            ...prev,
            "filters": filterModel.items.map(f => ({
                "filter": f.columnField,
                "operation": f.operatorValue,
                "value": !f.value ? [] : Array.isArray(f.value) ? f.value : [f.value]
            }))
        }));
    }, []);
    const handlePageChange = React.useCallback((newPage) => {
        setInputFilters(prev => ({...prev, "pagination": {...prev.pagination, "page": newPage}}));
    }, []);
    const handlePageSizeChange = React.useCallback((newPageSize) => {
        setInputFilters(prev => ({...prev, "pagination": {"page": 0, "pageSize": newPageSize}}));
    }, []);
    const handleSortModelChange = React.useCallback((newSortModel) => {
        if (newSortModel.length > 0) setInputFilters(prev => ({...prev, "sort": newSortModel[0]}));
    }, []);

    const saveEditVendor = (id, field, value, row) => {
        enqueueSnackbar(t('saving...'), {variant: "info"});
        put(DASH_VENDORS, {elem: row.uid, body: {[field]: value},})
            .then(() => {
                enqueueSnackbar(t('saved'), {variant: "success"});
            })
            .catch(e => enqueueSnackbar(getErrorMessage(e), {variant: "error"}))
            .finally(() => queryClient.invalidateQueries([DASH_VENDORS]));
    };

    const columns = [
        {
            headerName: t('vendorID'),
            field: 'uid',
            width: 220,
            filterable: false,
            //hide: true,
        }, {
            headerName: ' ',
            field: 'visible',
            width: 80,
            filterable: false,
            sortable: false,
            renderCell: (params) => <Tooltip title={params.row.visible ? t('visible') : t('hidden')}>
                <div><RenderBoolean params={params} saveEdit={saveEditVendor}/></div>
            </Tooltip>
        }, {
            headerName: t('businessName'),
            field: 'businessName',
            minWidth: 220,
        }, {
            headerName: t('address'),
            field: 'address',
            minWidth: 170,
        },
        {
            headerName: t('postalCode'),
            field: 'postalCode',
            minWidth: 170,
            filterable: false,
        }, {
            headerName: t('city'),
            field: 'city',
            minWidth: 170,
        }, {
            headerName: t('province'),
            field: 'province',
            minWidth: 170,
        }, {
            headerName: t('country'),
            field: 'country',
            minWidth: 170,
            filterable: false,
        }, {
            headerName: t('vatNumber'),
            field: 'vatNumber',
            minWidth: 150,
        }, {
            headerName: t('email'),
            field: 'email',
            minWidth: 170,
        }, {
            headerName: t('firstName'),
            field: 'firstName',
            minWidth: 170,
        }, {
            headerName: t('lastName'),
            field: 'lastName',
            minWidth: 170,
        }, {
            headerName: t('phoneNumber'),
            field: 'phone',
            minWidth: 150,
        }, {
            headerName: t('releasedCoupon'),
            field: 'totalValueReleasedCoupon',
            minWidth: 170,
            filterable: false,
        }, {
            headerName: t('assignedCoupon'),
            field: 'numberAssignedCoupon',
            minWidth: 170,
            filterable: false,
            sortable: false,
        }, {
            headerName: t('details'),
            field: 'id',
            minWidth: 130,
            renderCell: (params) => <Link
                to={"/vendors/" + params.row.uid}><IconButton><Visibility/></IconButton></Link>,
            filterable: false,
            sortable: false,
        },
    ];


    return <Paper style={{padding: "2rem"}}>
        <NTMXGrid
            key={"vendors-list-table"}
            columns={columns}
            rows={vendors?.content || []}
            title={t('vendors')}
            getRowId={(row) => row.uid}
            loading={status === "loading"}
            onFilterModelChange={handleFilterModelChange}
            filterMode="server"
            onSortModelChange={handleSortModelChange}
            sortingMode="server"
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
            paginationMode="server"
            rowCount={vendors?.totalElements || vendors?.page?.totalElements || 0}
        />
    </Paper>

}
